module.exports = __webpack_public_path__ + "img/MapMonitoring.d9bd0d1c.svg";